module.exports = __webpack_public_path__ + "img/plane.674a8bcd.png";